(() => {
  function inspect(items) {
    items=items.map(item=>({...item,properties:Array.isArray(item.properties)?Object.fromEntries(item.properties):item.properties}));
    const groups=new Map();
    for(const item of items){
      const id=item.properties?._cdb_configuration;
      if(!id||item.properties._cdb_version!=='2')continue;
      if(!groups.has(id))groups.set(id,[]);
      groups.get(id).push(item);
    }
    return [...groups].map(([id,lines])=>{
      const manifest=lines[0].properties._cdb_manifest;
      const expected=(manifest||'').split('|').map(x=>x.split(':'));
      const beds=lines.filter(x=>x.properties._cdb_role==='bed');
      const quantity=beds.reduce((sum,x)=>sum+x.quantity,0);
      const actual=new Map();
      for(const line of lines){const key=line.properties._cdb_role+':'+line.variant_id;actual.set(key,(actual.get(key)||0)+line.quantity);}
      const valid=quantity>0 && expected.length===actual.size && expected.every(([role,variant,ratio])=>actual.get(role+':'+variant)===Number(ratio)*quantity) && lines.every(x=>x.properties._cdb_manifest===manifest);
      return {id,lines,quantity,valid};
    });
  }
  if(typeof module!=='undefined')module.exports={inspect};
  if(typeof document==='undefined')return;
  const route=path=>(window.Shopify?.routes?.root||'/')+path;
  const read=async()=>{const r=await fetch(route('cart.js'),{cache:'no-store'});if(!r.ok)throw new Error('Kunne ikke kontrollere handlekurven. Prøv igjen.');return r.json();};
  let busy=false;
  class CdbCartGroup extends HTMLElement {
    connectedCallback(){
      if(this.ready)return;this.ready=true;
      const data=JSON.parse(this.querySelector('[data-cdb-lines]').textContent);
      const group=inspect(data)[0];
      if(!group?.valid){
        this.dataset.invalid='true';
        this.querySelector('[data-cdb-update]').disabled=true;
        this.querySelector('[data-cdb-message]').textContent='Konfigurasjonen er ufullstendig eller har ulike antall. Fjern hele konfigurasjonen og bygg den på nytt før betaling.';
      }
      this.addEventListener('click',async event=>{
        const remove=event.target.closest('[data-cdb-remove]');
        if(!remove&&!event.target.closest('[data-cdb-update]'))return;
        event.preventDefault();
        if(busy)return;
        const quantity=remove?0:Number(this.querySelector('[data-cdb-quantity]').value);
        const message=this.querySelector('[data-cdb-message]');
        if(!Number.isInteger(quantity)||quantity<0||quantity>10||(!remove&&quantity===0)){message.textContent='Velg et helt antall fra 1 til 10.';return;}
        busy=true;
        document.querySelectorAll('cdb-cart-group button').forEach(x=>x.disabled=true);
        message.textContent='Oppdaterer hele konfigurasjonen…';
        try{
          const before=await read();
          const current=inspect(before.items).find(x=>x.id===this.dataset.group);
          if(!current)throw new Error('Konfigurasjonen finnes ikke lenger. Last inn siden på nytt.');
          if(quantity&&!current.valid)throw new Error('Konfigurasjonen er ufullstendig. Fjern den og bygg på nytt.');
          const updates=Object.fromEntries(current.lines.map(x=>[x.key,quantity?x.quantity/current.quantity*quantity:0]));
          const response=await fetch(route('cart/update.js'),{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates})});
          if(!response.ok)throw new Error('Kunne ikke oppdatere alle delene. Last inn handlekurven på nytt før du fortsetter.');
          const after=await response.json();
          const result=inspect(after.items).find(x=>x.id===this.dataset.group);
          if(quantity?(!result?.valid||result.quantity!==quantity):!!result)throw new Error('Kontroller handlekurven: alle delene ble ikke oppdatert.');
          window.location.assign(route('cart')+'');
        }catch(error){
          message.textContent=error.message;
          busy=false;
          document.querySelectorAll('cdb-cart-group').forEach(group=>group.querySelectorAll('button').forEach(x=>x.disabled=!!group.dataset.invalid&&x.hasAttribute('data-cdb-update')));
        }
      });
    }
  }
  customElements.define('cdb-cart-group',CdbCartGroup);
  const preventInvalid=event=>{
    const checkout=event.type==='submit'?event.submitter:event.target.closest('[name="checkout"],a[href*="/checkout"]');
    if(!checkout)return;
    const invalid=document.querySelector('cdb-cart-group[data-invalid="true"]');
    if(busy||invalid){event.preventDefault();event.stopImmediatePropagation();invalid?.scrollIntoView({block:'center'});}
  };
  document.addEventListener('click',preventInvalid,true);
  document.addEventListener('submit',preventInvalid,true);
})();